/**
 * initTags
 */
const INIT_TAGS = {
  workersActive: 'workersActive',
};

export default INIT_TAGS;
